import React from "react";
import {Alert} from "../../../ui/shared/Alert/Alert";
import moment from "moment/moment";
import EventCity from "../../../eventCities/types/EventCity";
import useCustomerContext from "../../../customers/hooks/useCustomerContext";
import useTranslate from "../../../core/languages/hooks/useTranslate";

interface PackageWizardAlertProps {
  eventCity?: EventCity;
  accommodationDates?: {
    startDate: string,
    endDate: string
  };
}

const PackageWizardAlert: React.FC<PackageWizardAlertProps> = ({eventCity, accommodationDates}) => {
  const {languageCode} = useCustomerContext();
  const t = useTranslate();

  return (
    <Alert type="success" closable={false} className="mb-6 border-l-4 border-green-500">
      <span className="font-medium">
        {t("packages.message.winnerPackageNoticeBanner", {
          cityEvent: eventCity?.eventCustomName[languageCode] || '',
          startDate: moment(accommodationDates?.startDate).format('DD/MM/YYYY'),
          endDate: moment(accommodationDates?.endDate).format('DD/MM/YYYY'),
        })}
      </span>
    </Alert>
  );
};

export default PackageWizardAlert;
